import { render, staticRenderFns } from "./HomeGameWheel.vue?vue&type=template&id=77982b6e&scoped=true&"
import script from "./HomeGameWheel.vue?vue&type=script&lang=js&"
export * from "./HomeGameWheel.vue?vue&type=script&lang=js&"
import style0 from "./HomeGameWheel.vue?vue&type=style&index=0&id=77982b6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77982b6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77982b6e')) {
      api.createRecord('77982b6e', component.options)
    } else {
      api.reload('77982b6e', component.options)
    }
    module.hot.accept("./HomeGameWheel.vue?vue&type=template&id=77982b6e&scoped=true&", function () {
      api.rerender('77982b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/HomeGameWheel.vue"
export default component.exports